import type { InspectPin } from '../inspectPin'

import { snapshot } from 'valtio'
import { inspectPin } from '../inspectPin'

export function getInspectPin(immutable?: boolean): InspectPin {
  return immutable && inspectPin.pin ? snapshot(inspectPin.pin) : inspectPin.pin
}
